import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2xjdvub937: FaireBrandEntity = {
  token: "b_2xjdvub937",
  type: "brand",
  name: "Ceres Gourmet",
  avatarUrl:
    "https://cdn.faire.com/fastly/b37cc6f4074d3c4a8d45818a03d750546c528a2df89ec76b830f75af6361d316.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1a0cb5a7a15a0f6385e89cb6dbce3a060dd3159b5e49852356072719ed1fc356.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b37cc6f4074d3c4a8d45818a03d750546c528a2df89ec76b830f75af6361d316.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1a0cb5a7a15a0f6385e89cb6dbce3a060dd3159b5e49852356072719ed1fc356.jpeg",
  location: "Rutherford, NJ, USA",
  minimumOrderDollars: 139,
  rating: 4.6,
  reviewCount: 51,
  isInsider: true,
  description:
    "Ceres Gourmet is not just any snack company - we are passionate about bringing the world to your doorstep. Our goal is to showcase the rich and diverse flavors of different cultures through our carefully curated selection of international snacks. From the sweet and aromatic Turkish Delight to the savory Dark Chocolate coated orange peel candy, our snack packages offer a journey through taste that you won't forget.\n\nAt Ceres Gourmet, we pride ourselves on our commitment to quality and authenticity. We work with trusted suppliers from around the globe to bring you snacks that are not only delicious, but also true to their origins. We understand that food is an integral part of culture and identity, and we strive to honor that in every package we deliver.\n\nWhether you are a seasoned traveler or simply an adventurous foodie, Ceres Gourmet has something for you. Our international snack package is the perfect way to explore new tastes and expand your palate. So why wait? Let us take you on a journey of flavor and discovery today!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:36.107Z",
    importedBy: "entity-db-cli",
  },
};
